import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { AppService } from '../../services/app.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-form',
  standalone: true,
  imports: [ReactiveFormsModule, TranslatePipe],
  templateUrl: './form.component.html',
  styleUrl: './form.component.scss'
})
export class FormComponent {

  form: FormGroup; 
  public submitted: boolean = false;
  public firstSubmitted: boolean = false;
  public loading: boolean = false;
  public isProduction: boolean = false;
  showTerms: boolean = false;

  public initLoading: boolean = true;

  imageBaseUrl:string = ''

  private $loadingStatus: Subscription;  

  constructor(private apiService: ApiService, private appService: AppService, private fb: FormBuilder) {
    this.$loadingStatus = this.appService.$loadingStatus.subscribe(data => { this.initLoading = data });
    this.form = this.fb.group({
      cardNumber: ['',       [
        Validators.required,
        Validators.pattern('^[0-9]{4}$'),
        Validators.minLength(4),
        Validators.maxLength(4)
      ]],
      mpId: ['', [
        Validators.required,
        Validators.pattern('([a-zA-Z0-9]){8,8}'),
        Validators.minLength(8),
        Validators.maxLength(8)
      ]]
    });

    this.imageBaseUrl = this.appService.ENV.IMAGE_BASE_URL;
  }

  onSubmit() {
    this.firstSubmitted = true;
    this.submitted = true;
    this.loading = true;

    if (this.form.valid) {
      const { cardNumber, mpId } = this.form.value;
      this.apiService.register(cardNumber, mpId);
    } else {
      this.loading = false;
      this.submitted = false;
      
      var formControls = Object.keys(this.form.controls);
      for(let i = 0; i < formControls.length; i++) {
        
        if (this.form.controls[formControls[i]].invalid) {
          const invalidElement = document.querySelector(`[formControlName="${formControls[i]}"]`) as HTMLElement;
          if (invalidElement) {
            invalidElement.focus()
          }
          break;
        }
      }
    }
  }
  onCloseTerms() {
    this.showTerms = false;
  }


  onKeydown(event: any){
    if(event.key === 'Enter'){
        this.showTerms = !this.showTerms;
    }
  }

  ngOnInit() {
    this.initLoading = this.appService.getLoadingStatus();

  }

  ngOnDestroy() {
    if (this.$loadingStatus) { this.$loadingStatus.unsubscribe(); }
  }
}
